import { render, staticRenderFns } from "./FiveAboutUser.vue?vue&type=template&id=3c7a26d6&scoped=true"
import script from "./FiveAboutUser.vue?vue&type=script&lang=js"
export * from "./FiveAboutUser.vue?vue&type=script&lang=js"
import style0 from "./FiveAboutUser.vue?vue&type=style&index=0&id=3c7a26d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7a26d6",
  null
  
)

export default component.exports